import { ERROR_FEEDBACK } from '../../actions/types';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case ERROR_FEEDBACK:
      return action.payload;
    default:
      return state;
  }
}
